import React from 'react';

export default function Privacy() {
  return (
    <div className="max-w-2xl mx-auto p-8 bg-white rounded-lg shadow mt-8 animate-fade-in">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-4">Effective as of June 01, 2025.<br/>Suanfamama. (&quot;we&quot;, &quot;us&quot; or &quot;our&quot;) provides advanced artificial intelligence (&quot;AI&quot;) platforms, including Fashion Buyer Agent. This Privacy Policy describes how we process personal information that we collect through the AI platform, related mobile apps and browser extensions, and any of our other digital or online properties or services that link to this Privacy Policy (collectively, the &quot;Service&quot;).</p>
      <p className="mb-4 font-semibold">NOTICE TO EUROPEAN USERS: Please see the Notice to European Users section for additional information for individuals located in the European Economic Area or United Kingdom (which we refer to as “Europe”, and “European” should be understood accordingly) below.</p>
      <h2 className="text-lg font-semibold mt-6 mb-2">Index</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Personal information we collect</li>
        <li>Tracking and other technologies</li>
        <li>How we use your personal information</li>
        <li>How we share your personal information</li>
        <li>Your choices</li>
        <li>Other sites and services</li>
        <li>Security</li>
        <li>International data transfers</li>
        <li>Children</li>
        <li>Changes to this Privacy Policy</li>
        <li>How to contact us</li>
        <li>Notice to European users</li>
      </ul>
    </div>
  );
} 